/**
 * Bottom tab bar — mobile only (<lg).
 * 4 items: Vandaag · Oefenen · Woorden · Voortgang.
 * Grammatica + Instellingen + account are reachable from MobileTopBar.
 */
import { NavLink } from "react-router";
import { useT } from "../../lib/use-t";
import { TAB_BAR_ITEMS } from "./navItems";

export function TabBar() {
  const t = useT();

  return (
    <nav
      className="lg:hidden flex justify-around items-center border-t border-[var(--border)] bg-[var(--panel)] px-1.5 pt-[9px] pb-[14px] sticky bottom-0 z-10"
      aria-label={t("chrome.nav.tabBarAriaLabel")}
    >
      {TAB_BAR_ITEMS.map(({ key, labelKey, route, Icon }) => (
        <NavLink
          key={key}
          to={route}
          className={({ isActive }) =>
            [
              "flex flex-col items-center gap-1 text-[10.5px] font-semibold px-3 py-1 rounded-[var(--radius-sm)] transition-colors duration-150",
              isActive
                ? "text-[var(--accent)]"
                : "text-[var(--ink-faint)] hover:text-[var(--ink)]",
            ].join(" ")
          }
        >
          <span className="w-[22px] h-[22px] flex items-center justify-center">
            <Icon width={21} height={21} />
          </span>
          {t(labelKey)}
        </NavLink>
      ))}
    </nav>
  );
}
